export default class SectionMap
{
    price = "";
    address = "";
    dateDelivery = false;
    timeDelivery = false;

    constructor(params)
    {}

    getAddress()
    {
        return this.address;
    }

    getPrice()
    {
        return this.price;
    }

    getDateDelivery()
    {
        return this.dateDelivery;
    }

    getTimeDelivery()
    {
        return this.timeDelivery
    }

    getHtml()
    {
        return ``;
    }
}


